import React from 'react'
import PropTypes from 'prop-types'
import {
  TableWrapper,
  Table,
  TableHead,
  TableRow,
  TableData,
  TableBody,
} from './index.style'

const TextSection = ({ content }) => {
  return (
    <TableWrapper>
      <Table>
        {content.map((row, key) => {
          return key === 0 ? (
            <TableHead key={key}>
              <TableRow>
                <TableData>{row[0]}</TableData>
                <TableData>{row[1]}</TableData>
                <TableData>{row[2]}</TableData>
              </TableRow>
            </TableHead>
          ) : (
            <TableBody key={key}>
              <TableRow>
                <TableData>{row[0]}</TableData>
                <TableData>{row[1]}</TableData>
                <TableData>{row[2]}</TableData>
              </TableRow>
            </TableBody>
          )
        })}
      </Table>
    </TableWrapper>
  )
}

TextSection.propTypes = {
  content: PropTypes.array,
}

export default TextSection
